import { getSchema as getSchema1, uiSchema as uiSchema1, } from "./schema.addAddress.1";
export default (function (defaultValues, extraData) {
    if (defaultValues === void 0) { defaultValues = {}; }
    if (extraData === void 0) { extraData = { withGoogleMapsInput: true }; }
    return [
        {
            schema: getSchema1(defaultValues),
            uiSchema: uiSchema1(extraData),
        },
    ];
});
